// import { DataIndex, DataType } from "./type";
import { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { DataIndex, DataType } from "./Type";

const data: DataType[] = [
  {
    column_1: "1",
    column_2: "John Brown",
    column_3: "32",
    column_4: "New York No. 1 Lake Park",
    column_5: "New York No. 1 Lake Park",
    column_6: "New York No. 1 Lake Park",
    column_7: "New York No. 1 Lake Park",
    column_8: "New York No. 1 Lake Park",
    column_9: "New York No. 1 Lake Park",
    column_10: "New York No. 1 Lake Park",
  },
  {
    column_1: "1",
    column_2: "John Brown",
    column_3: "32",
    column_4: "New York No. 1 Lake Park",
    column_5: "New York No. 1 Lake Park",
    column_6: "New York No. 1 Lake Park",
    column_7: "New York No. 1 Lake Park",
    column_8: "New York No. 1 Lake Park",
    column_9: "New York No. 1 Lake Park",
    column_10: "New York No. 1 Lake Park",
  },
  {
    column_1: "1",
    column_2: "John Brown",
    column_3: "32",
    column_4: "New York No. 1 Lake Park",
    column_5: "New York No. 1 Lake Park",
    column_6: "New York No. 1 Lake Park",
    column_7: "New York No. 1 Lake Park",
    column_8: "New York No. 1 Lake Park",
    column_9: "New York No. 1 Lake Park",
    column_10: "New York No. 1 Lake Park",
  },
];

function TableContractorExtract() {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "م",
      dataIndex: "column_1",
      key: "name",
      width: 30,
    },
    {
      title: "رقم المستخلص",
      dataIndex: "column_2",
      key: "column_2",
      width: 130,
      ...getColumnSearchProps("column_2"),
      sorter: (a, b) => a.column_2.length - b.column_2.length,
    },
    {
      title: "اسم المقاول",
      dataIndex: "column_3",
      key: "column_3",
      width: 130,
      ...getColumnSearchProps("column_3"),
      sorter: (a, b) => a.column_3.length - b.column_3.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "تاريخ المستخلص",
      dataIndex: "column_4",
      key: "column_4",
      width: 130,
      ...getColumnSearchProps("column_4"),
      sorter: (a, b) => a.column_4.length - b.column_4.length,
    },
    {
      title: "اجمالى القيمه",
      dataIndex: "column_5",
      key: "column_5",
      width: 140,
      ...getColumnSearchProps("column_5"),
      sorter: (a, b) => a.column_5.length - b.column_5.length,
    },
    {
      title: "المشروع",
      dataIndex: "column_6",
      key: "column_6",
      width: 130,
      ...getColumnSearchProps("column_6"),
      sorter: (a, b) => a.column_6.length - b.column_6.length,
    },
    {
      title: "ملاحظات",
      dataIndex: "column_7",
      key: "column_7",
      width: 130,
    },
    {
      title: "",
      dataIndex: "Events",
      key: "Events",
      render: (_, record) => (
        <div className="grid grid-cols-2 items-center justify-center gap-1">
          <Button type="primary">طباعه</Button>
          <Button type="primary">عرض القيد </Button>
          <Button type="primary">تعديل</Button>
          <Button type="primary" danger>
            حذف
          </Button>
        </div>
      ),
      width: 150,
    },
  ];

  return (
    <>
      <Table
        
        columns={columns}
        pagination={false}
        scroll={{ x: 1800, y: 350 }}
        dataSource={data}
        bordered
      />
    </>
  );
}

export default TableContractorExtract;
